/**
 * Определяет, запущено ли приложение как PWA (standalone, fullscreen, minimal-ui).
 * В PWA заголовок окна берётся только из manifest name, document.title не отображаем.
 */
export const isPWAWindow = (): boolean =>
  typeof window !== 'undefined' &&
  window.matchMedia('(display-mode: standalone), (display-mode: fullscreen), (display-mode: minimal-ui)').matches
